// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Sf","container":"e_Tf","right":"e_Uf","image":"e_Vf","scoreLine":"e_Wf","scoreRing":"e_Xf","badge":"e_Yf","badgeImage":"e_Zf","badgeRing":"e__f","large":"e_0f"};